module.exports = __webpack_public_path__ + "d3bd6b1980403d881af7f07b1d9c7b8b.jpg";